import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDibIconWord = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26.5 24.9",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 16.3,
			y: 3.3,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			width: 9.4,
			height: 18.3
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			children: [
				/* @__PURE__ */ _jsx("line", {
					x1: 16.5,
					x2: 23,
					y1: 7.7,
					y2: 7.7
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: 16.5,
					x2: 23,
					y1: 10.9,
					y2: 10.9
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: 16.5,
					x2: 23,
					y1: 14,
					y2: 14
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: 16.5,
					x2: 23,
					y1: 17.2,
					y2: 17.2
				})
			]
		}),
		/* @__PURE__ */ _jsx("polygon", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			points: "0.8,3.9 0.8,21 16.3,24 16.3,0.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M3.2,9l1.8,7h1.7l1.3,-5.3 1.3,5.3h1.8l1.8,-7h-1.5l-1.4,5.7 -1.4,-5.7h-1.4l-1.3,5.7 -1.2,-5.7z"
		})
	]
});
export default SvgDibIconWord;
